import React, { useState } from "react";
import StarIcon from '@mui/icons-material/Star';

const Reviews = () => {
  const [reviews, setReviews] = useState([]);
  const [newReview, setNewReview] = useState(""); 
  const [rating, setRating] = useState(4); 
  const [hover, setHover] = useState(null); 

  const handleAddReview = () => {
    if (!newReview.trim() || rating === 0) {
      alert("Please add a review and select a rating.");
      return;
    }

    setReviews([
      ...reviews,
      { text: newReview, rating, id: Date.now() }
    ]);

    setNewReview("");
    setRating(0);
    setHover(null);
  };

  return (
    <div style={{ maxWidth: "600px", margin: "0", padding:"0", }}>
      <div style={{ marginBottom: "0" }}>
        <div style={{ display: "flex", gap: "5px" }}>
          {[...Array(5)].map((_, index) => {
            const starValue = index + 1;
            return (
              <StarIcon
                key={index}
                size={30}
                style={{
                  cursor: "pointer",
                  color: starValue <= (hover || rating) ? "#ffc107" : "#e4e5e9",
                }}
                onMouseEnter={() => setHover(starValue)}
                onMouseLeave={() => setHover(null)}
                onClick={() => setRating(starValue)}
              />
            );
          })}
        </div>
        
      </div>

    </div>
  );
};

export default Reviews;
